// Api End Point
export const URL = 'spatial/'

// Name
export const MODEL = 'PatriciaRegion'

// Model Properties
export const PROP_ID = 'id'
export const PROP_SPATIAL_ID = 'id'
export const PROP_LABEL = 'label'
export const PROP_ASSET = 'asset'
export const PROP_SHAPE = 'shapeData'
